import { render, staticRenderFns } from "./BatchOperateSortNumber.vue?vue&type=template&id=f225c564&scoped=true"
import script from "./BatchOperateSortNumber.vue?vue&type=script&lang=ts"
export * from "./BatchOperateSortNumber.vue?vue&type=script&lang=ts"
import style0 from "./BatchOperateSortNumber.vue?vue&type=style&index=0&id=f225c564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f225c564",
  null
  
)

export default component.exports